import { memo } from 'react';
import { Skeleton } from '@material-ui/lab';
import { SText } from '@setvi/shared/components';
import type { QuoteProductDTO } from '@setvi/shared/services/react-query';
import { FirstRowBox, RowContainer, SecondRowBox } from '../styled';

interface CostColumnProps {
  product: QuoteProductDTO;
}

export const CostColumn = memo(({ product }: CostColumnProps) => {
  const totalPrices = (product?.sell ?? 0) * (product?.quantity || 1);

  if (product?.isPricingFetching) {
    return (
      <RowContainer>
        <FirstRowBox>
          <Skeleton variant="rect" width={100} height={40} />
        </FirstRowBox>
        <SecondRowBox hasNote={!!product?.note} />
      </RowContainer>
    );
  }

  return (
    <RowContainer>
      <FirstRowBox>
        <SText
          weight="bold"
          title={Number(totalPrices)?.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}
        />
      </FirstRowBox>
      <SecondRowBox hasNote={!!product?.note} />
    </RowContainer>
  );
});

CostColumn.displayName = 'CostColumn';
